import DialogCopy from './DialogCopy'

export default DialogCopy
